import { Typography } from '@mui/material'
import React from 'react'

export const FindMyCowTitle = ({ title }) => {
  if (!title) return null

  return <Typography variant="h5">{title}</Typography>
}
